import React from 'react'
import Iframe from 'react-iframe'
import '../styles/contactus.css'
import ContactForm from '../components/contact-form'

function Contact(){
    return (
        <div className="about_wrapper page_content">
            <h1>
                Get In Touch
            </h1>

            <p></p>

            <div class="col-md-12 row">
					<div class="col-md-6">
						<h3>Johannesburg - Centurion (Head Office)</h3>
						<div>
						<p>369 Panaroma Road <br/>
                        Woodwind Estate<br/>
                        59 Oboni Park<br/>
                        Centurion 0066</p>
						<p>+27 62 2429 228</p>
						<p><span className="email"><a href="mailto:info@smartks.co.za">info@smartks.co.za</a> </span></p>
						</div>
					</div>
					
					<div class="col-md-6">
                    <Iframe url="https://maps.google.com/maps?q=Woodwind%20Estate%20Centurion%200066&t=&z=13&ie=UTF8&iwloc=&output=embed"
                    width="400px"
                    height="450px"
                    id="myId"
                    className="myClassname"
                    display="initial"
                    position="relative"/>
						
					</div>
            </div>

            <div className="col-md-12 row contact_form_wrapper">
                <ContactForm/>
            </div>
        </div>
    );
}

export default Contact;